import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { User } from './../models/user';
import { ClinicContact } from './../models/clinic';
import { VaccineValence, VaccineLabel, VaccineConfiguration } from './../models/vaccine';
import { StorageService } from './storage.service'
import { AlertController } from '@ionic/angular';
import { NetworkService } from './network.service';
import { UserService } from './user.service';
import { DateUtilsService } from './date-utils.service';
import { IndexedDbService } from './indexed-db.service';
import { blobToBase64 } from '../utils'
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ClinicService {
  clinicContacts: ClinicContact[] = [];

  constructor(
        private http: HttpClient,
        public storageService: StorageService,
        public networkService: NetworkService,
        private translate: TranslateService,
        private dateUtils: DateUtilsService,
        private userService: UserService,
        public indexedDbService: IndexedDbService,
        public alertController: AlertController) { }
        
  
  dbGetClinicContactsOfUserLatestUpdate: Date | null = null;
  dbGetClinicContactsOfUser(forceUpdate: boolean, userId: number): Promise<ClinicContact[] | null> {
    var cache: ClinicContact[] = this.clinicContacts.filter(a => a.userId == userId)
    return new Promise((resolve) => {
      if ((forceUpdate || cache.length == 0 || !this.dbGetClinicContactsOfUserLatestUpdate || Math.abs(this.dbGetClinicContactsOfUserLatestUpdate.getTime() - (new Date()).getTime()) > 5 * 60 * 1000) && this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        this.http.get<any[]>(environment.API_URL + 'clinic/ws_private/' + userId + '/GetClinicContactsOfUser/', {headers : headers}).subscribe(async (response: { [key: string]: any }) => {
          this.dbGetClinicContactsOfUserLatestUpdate = new Date()
          var clinicContacts: ClinicContact[] =[]

          for(let a of response['clinicContacts']) {
            var clinicContact = this.clinicContacts.find(b => b.id == a['id'])
            if(!clinicContact){
              clinicContact = new ClinicContact()
              this.clinicContacts.push(clinicContact);
            }
            clinicContact.id = a['id']
            clinicContact.userId = a['userId']
            clinicContact.name = a['name']
            clinicContact.phone = a['phone']
            clinicContact.email = a['email']

            clinicContacts.push(clinicContact);

          }

          resolve(clinicContacts);
        },
        () => {
          resolve(this.clinicContacts.filter(a => a.userId == userId));
        })
      } else {
        resolve(cache);
      }
    });
  }

  dbGetClinicContact(forceUpdate: boolean, clinicContactId: number | null): Promise<ClinicContact | null> {
    var cache: ClinicContact | undefined = this.clinicContacts.find(a => a.id == clinicContactId)
    return new Promise((resolve) => {
      if ((!clinicContactId || forceUpdate || !cache) && this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });

        var url = environment.API_URL + 'clinic/ws_private/' + clinicContactId + '/GetClinicContact/';
        if(clinicContactId == null)
          url = environment.API_URL + 'clinic/ws_private/GetClinicContactBlank/';

        this.http.get<any[]>(url, {headers : headers}).subscribe(async (response: { [key: string]: any }) => {
          var clinicContact = this.clinicContacts.find(a => a.id == clinicContactId)
          if(!clinicContact){
            clinicContact = new ClinicContact()
            this.clinicContacts.push(clinicContact);
          }
          
          clinicContact.id = response['id']
          clinicContact.userId = response['userId']
          clinicContact.name = response['name']
          clinicContact.phone = response['phone']
          clinicContact.email = response['email']

          resolve(clinicContact);
        },
        () => {
          resolve(this.clinicContacts.find(a => a.id == clinicContactId) ?? null);
        })
      } else {
        resolve(cache ?? null);
      }
    });
  }

  dbSaveClinicContact(clinicContact: ClinicContact) {
    return new Promise((resolve, reject) => {
      if (this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        let formData: { [key: string]: any } = {};
        formData["id"] = clinicContact.id
        formData["name"] = clinicContact.name;
        formData["phone"] = clinicContact.phone;
        formData["email"] = clinicContact.email;

        this.http.post<any[]>(environment.API_URL + 'clinic/ws_private/UpdateClinicContact/', formData, {headers : headers}).subscribe({
          next: (response: { [key: string]: any }) => {
            if (clinicContact.id == null) {
              clinicContact.id = response['id']
            }
            resolve(clinicContact);
          },
          error: async (error) => {
            reject(error);
          }
        });
      } else {
        this.indexedDbService.addItem({'obj': clinicContact, 'action': 'save'}).subscribe(() => {});
        resolve(clinicContact)
      }
    });
  }

  dbDeleteClinicContact(clinicContact: ClinicContact) {
    return new Promise((resolve, reject) => {
      if (this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        let formData: { [key: string]: any } = {};
        formData["id"] = clinicContact.id;
        
        this.http.post<any[]>(environment.API_URL + 'clinic/ws_private/DeleteClinicContact/', formData, {headers : headers}).subscribe({
          next: (response: { [key: string]: any }) => {
            resolve(clinicContact);
          },
          error: async (error) => {
            reject(error);
          }
        });
      } else {
        this.indexedDbService.addItem({'obj': clinicContact, 'action': 'delete'}).subscribe(() => {});
        resolve(clinicContact)
      }
    });
  }
  
}
